import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SelectField,
  SubmitButton,
  CancelPopupButton,
} from "../../../../ui/FormElement";
import axios from "axios";

import { useTopicContext } from "../../../../contexts/TopicContext";
import routes from "../../../../app/routes";

export default function Form() {
  let FormSchema = Yup.object().shape({
    title: Yup.string().required("Topic Name is required"),
    topicCategoryId: Yup.number().typeError("Please, choose Topic Category"),
  });

  let [loader, setLoader] = useState(false);
  let [categories, setCategories] = useState(null);

  const { dispatch, state, actions } = useTopicContext();

  const [formData, setFormData] = useState({
    title: "",
    topicCategoryId: null,
  });

  const loadCategories = () => {
    axios.get(routes.api.topic_categories.index).then((resp) => {
      let values = resp.data.data.map(function (item) {
        return {
          value: item.id,
          label: item.attributes.title,
        };
      });

      setCategories(values);
    });
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.saveTopic(
      dispatch,
      values,
      (row) => {
        setLoader(false);
        actions.hideModal(dispatch);
        actions.editTopic(row.id);
      },
      (errorData) => {
        let newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace("/data/attributes/", "")] =
            item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      }
    );
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="title"
        label={
          <>
            <span>Topic Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <SelectField
        name="topicCategoryId"
        label={
          <>
            <span>Topic Category</span>
            <abbr title="required">*</abbr>
          </>
        }
        placeholder={
          categories == null
            ? "Categories is loading ..."
            : "Choose Category..."
        }
        options={categories}
        menuPlacement="auto"
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={() => actions.hideModal(dispatch)}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Save"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
